import PropTypes from 'prop-types';
import { useCallback } from 'react';
// @mui
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { Select } from '@mui/material';

// ----------------------------------------------------------------------

export default function UserTableToolbar({
    filters,
    onFilters,
    //
    roleOptions,
    handleChange, selectedProject
}) {
    const popover = usePopover();

    const handleFilterName = useCallback(
        (event) => {
            onFilters('name', event.target.value);
        },
        [ onFilters ]
    );

    const handleFilterRole = useCallback(
        (event) => {
            onFilters(
                'role',
                typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value
            );
        },
        [ onFilters ]
    );

    return (
        <>
            <Stack
                spacing={ 2 }
                alignItems={ { xs: 'flex-end', md: 'center' } }
                direction={ {
                    xs: 'column',
                    md: 'row',
                } }
                sx={ {
                    p: 2.5,
                    pr: { xs: 2.5, md: 1 },
                } }
            >
                <Select
                    sx={ { minWidth: 150, height: 52 } }
                    value={ selectedProject }
                    onChange={ handleChange }
                >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Assign to me">Assign to me</MenuItem>
                </Select>




                <Stack direction="row" alignItems="center" spacing={ 2 } flexGrow={ 1 } sx={ { width: 1 } }>
                    <TextField
                        fullWidth
                        value={ filters.name }
                        onChange={ handleFilterName }
                        placeholder="Search..."
                        InputProps={ {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon="eva:search-fill" sx={ { color: 'text.disabled' } } />
                                </InputAdornment>
                            ),
                        } }
                    />

                    <IconButton onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </Stack>
            </Stack>



            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >


                <MenuItem
                    onClick={ () => {
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:import-bold" />
                    Import
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:export-bold" />
                    Export
                </MenuItem>
            </CustomPopover>
        </>
    );
}

UserTableToolbar.propTypes = {
    filters: PropTypes.object,
    onFilters: PropTypes.func,
    roleOptions: PropTypes.array,
};
